import React from "react";
import { useParams, Link } from "react-router-dom";
import { Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import "./GalleryDetail.css";

// Imported images
import tmrt from "../../assets/gallery/tmrt/1-1.jpg";
import tmrt_2 from "../../assets/gallery/tmrt/1-2.jpg";
import tmrt_3 from "../../assets/gallery/tmrt/1-3.jpg";
import tmrt_4 from "../../assets/gallery/tmrt/1-4.jpg";
import tmrt_5 from "../../assets/gallery/tmrt/1-5.jpg";
import tmrt_6 from "../../assets/gallery/tmrt/1-6.jpg";

import fire from "../../assets/gallery/消防節/4-1.jpg";
import fire_2 from "../../assets/gallery/消防節/4-2.jpg";
import fire_3 from "../../assets/gallery/消防節/4-3.JPG";
import fire_4 from "../../assets/gallery/消防節/4-4.JPG";
import fire_5 from "../../assets/gallery/消防節/4-5.JPG";
import fire_6 from "../../assets/gallery/消防節/4-6.JPG";
import fire_7 from "../../assets/gallery/消防節/4-7.JPG";
import fire_8 from "../../assets/gallery/消防節/4-8.JPG";
import fire_9 from "../../assets/gallery/消防節/4-9.JPG";

import dragon from "../../assets/gallery/dragon/9-1.jpg";
import dragon_2 from "../../assets/gallery/dragon/9-2.jpg";
import dragon_3 from "../../assets/gallery/dragon/9-3.jpg";

import tmrt02 from "../../assets/gallery/tmrt2/15-1.jpg";
import tmrt02_2 from "../../assets/gallery/tmrt2/15-2.jpg";
import tmrt02_3 from "../../assets/gallery/tmrt2/15-3.jpg";
import tmrt02_4 from "../../assets/gallery/tmrt2/15-4.jpg";

import gal01 from "../../assets/gallery/gal01.jpg";
import gal02 from "../../assets/gallery/gal02.jpg";
import gal03 from "../../assets/gallery/gal03.jpg";
import gal04 from "../../assets/gallery/gal04.jpg";
import gal05 from "../../assets/gallery/gal05.png";
import gal06 from "../../assets/gallery/gal06.pdf";
import gal07 from "../../assets/gallery/gal07.jpg";
import gal08 from "../../assets/gallery/gal08.jpg";
import gal09 from "../../assets/gallery/gal09.jpg";
import gal10 from "../../assets/gallery/gal10.jpg";
import gal11 from "../../assets/gallery/gal11.jpg";
import gal12 from "../../assets/gallery/gal12.jpg";
import gal13 from "../../assets/gallery/gal13.jpg";
import gal14 from "../../assets/gallery/gal14.jpg";

const collections = [
    { id: 1, images: [tmrt, tmrt_2, tmrt_3, tmrt_4, tmrt_5, tmrt_6], title: "台中捷運家庭日_1", intro: "description" },
    { id: 2, images: [fire, fire_2, fire_3, fire_4, fire_5, fire_6, fire_7, fire_8, fire_9], title: "消防節", intro: "description" },
    { id: 3, images: [dragon, dragon_2, dragon_3], title: "燈會-龍", intro: "description" },
    { id: 4, images: [tmrt02, tmrt02_2, tmrt02_3, tmrt02_4], title: "台中捷運家庭日_2", intro: "description" },
    { id: 5, images: [gal01], title: "Animal Love", intro: "description" },
    { id: 6, images: [gal02], title: "Monster", intro: "description" },
    { id: 7, images: [gal03], title: "文聚冊市-創作傢俬拍賣會-2024", intro: "description" },
    { id: 8, images: [gal04], title: "Birthday_1", intro: "description" },
    { id: 9, images: [gal05], title: "埃及貓貓", intro: "description" },
    { id: 10, images: [gal06], title: "Birthday_2", intro: "description" },
    { id: 11, images: [gal07], title: "文聚冊市-作家衣櫃拍賣", intro: "description" },
    { id: 12, images: [gal08], title: "喫茶店", intro: "description" },
    { id: 13, images: [gal09], title: "萩椛皿", intro: "description" },
    { id: 14, images: [gal10], title: "BEE", intro: "description" },
    { id: 15, images: [gal11], title: "文聚冊市-創作傢俬拍賣會-2022", intro: "description" },
    { id: 16, images: [gal12], title: "霜氛", intro: "description" },
    { id: 17, images: [gal13], title: "盛夏森林的房客", intro: "description" },
    { id: 18, images: [gal14], title: "文具", intro: "description" },
];

const GalleryDetail = () => {
    const { id } = useParams();
    const collection = collections.find((col) => col.id === parseInt(id));

    if (!collection) return <Box>Collection not found</Box>;

    return (

        <Box
            sx={{
                marginTop: "40px",
                px: { xs: 2, md: 6 }, // responsive horizontal padding
                py: { xs: 8, md: 12 }, // responsive vertical padding
                minHeight: "calc(100vh - 140px)",
                position: "relative",
                maxWidth: "1200px",
                marginLeft: "auto",
                marginRight: "auto",
                overflowX: "hidden", // ensure no X scrollbar ever
            }}
        >


            {/* Main Content */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    gap: 6,
                    alignItems: "flex-start",
                }}
            >
                {/* Left: All Images stacked vertically */}
                <Box
                    sx={{
                        flex: "1 1 60%",
                        maxWidth: { xs: "100%", md: "600px" }, // reduced from 700px
                        display: "flex",
                        flexDirection: "column",
                        gap: 4,
                        overflowY: "visible",
                    }}
                >
                    {collection.images.map((img, idx) => (
                        <Box
                            key={idx}
                            component="img"
                            src={img}
                            alt={`${collection.title} image ${idx + 1}`}
                            className="fade-up"
                            sx={{
                                width: "100%",
                                borderRadius: 2,
                                objectFit: "contain",
                                userSelect: "none",
                                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                            }}
                            style={{
                                animationDelay: `${idx * 0.1}s`, // staggered delay
                            }}
                            draggable={false}
                        />
                    ))}

                </Box>

                {/* Right: Title + intro */}
                <Box
                    sx={{
                        flex: "1 1 35%",
                        maxWidth: { xs: "100%", md: "400px" },
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        paddingTop: { xs: 4, md: 0 },
                    }}
                >
                    <Box
                        sx={{
                            fontSize: { xs: "1.3rem", md: "1.8rem" },
                            fontWeight: "bold",
                            color: "#333",
                            marginBottom: 2,
                            fontFamily: "'Poppins', sans-serif",
                        }}
                    >
                        {collection.title}
                    </Box>
                    <Box
                        sx={{
                            fontSize: "0.8rem",
                            lineHeight: 1.6,
                            color: "#555",
                            whiteSpace: "pre-line",
                            fontFamily: "'Noto Sans TC', sans-serif",
                        }}
                    >
                        {collection.intro}
                    </Box>
                </Box>
            </Box>
            {/* Navigation Footer Row */}
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderTop: "1px solid #ddd",
                    marginTop: 8,
                    paddingTop: 4,
                    paddingBottom: 4,
                    fontFamily: "'Poppins', sans-serif",
                    fontSize: "1rem",
                    fontWeight: 500,
                    color: "#444",
                    flexWrap: "wrap",
                    gap: 2,
                }}
            >
                {/* Back to Work */}
                <Link to="/gallery" style={{ textDecoration: "none", color: "#444" }}>
                    Back to Gallery
                </Link>

                {/* Prev / Next */}
                <Box>
                    <span style={{ color: parseInt(id) === 1 ? "#ccc" : "#444" }}>
                        {parseInt(id) === 1 ? "prev" : (
                            <Link
                                to={`/gallery-detail/${parseInt(id) - 1}`}
                                style={{ textDecoration: "none", color: "#444" }}
                            >
                                prev
                            </Link>
                        )}
                    </span>{" "}
                    /{" "}
                    <span style={{ color: parseInt(id) === collections.length ? "#ccc" : "#444" }}>
                        {parseInt(id) === collections.length ? "next" : (
                            <Link
                                to={`/gallery-detail/${parseInt(id) + 1}`}
                                style={{ textDecoration: "none", color: "#444" }}
                            >
                                next
                            </Link>
                        )}
                    </span>
                </Box>
            </Box>

        </Box>
    );
};

export default GalleryDetail;
